<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<h3 class="h3">A<span class="smallcaps">LSO BY</span> C<span class="smallcaps">HRIS</span> M<span class="smallcaps">ACKOWSKI</span></h3>
<p class="noindent"><em class="italic">Decisions at Fredericksburg: The Fourteen Critical Decisions that Defined the Battle</em></p>
<p class="hang"><em class="italic">Grant’s Last Battle: The Story Behind the Personal Memoirs of Ulysses S. Grant</em></p>
<p class="hang"><em class="italic">The Great Battle Never Fought: The Mine Run Campaign, November 26-December 2, 1863</em></p>
<p class="hang"><em class="italic">Hell Itself: The Battle of the Wilderness, May 5-7, 1864</em></p>
<p class="hang"><em class="italic">Strike Them a Blow: Battle Along the North Anna River, May 21-25, 1864</em></p>
<p class="hang"><em class="italic">Traces of the Bloody Struggle: The Civil War at Stevenson Ridge, Spotsylvania Court House</em></p>
<p class="hang"><em class="italic">Chancellorsville’s Forgotten Front: The Battles of Second Fredericksburg and Salem Church, May 3, 1863</em> (with Kristopher D. White)</p>
<p class="hang"><em class="italic">Don’t Give an Inch: The Second Day at Gettysburg, July 2, 1863—From Little Round Top to Cemetery Ridge</em> (with Kristopher D. White and Daniel T. Davis)</p>
<p class="hang"><em class="italic">Fight Like the Devil: The First Day at Gettysburg, July 1, 1863</em> (with Kristopher D. White and Daniel T. Davis)</p>
<p class="hang"><em class="italic">The Last Days of Stonewall Jackson: The Mortal Wounding of the Confederacy’s Greatest Icon</em> (with Kristopher D. White)</p>
<p class="hang"><em class="italic">A Season of Slaughter: The Battle of Spotsylvania Court House, May 8-21, 1864</em> (with Kristopher D. White)</p>
<p class="hang"><em class="italic">Seizing Destiny: The Army of the Potomac’s “ Valley Forge” and the Civil War Winter that Saved the Union</em> (with Albert Z. Conner, Jr.)</p>
<p class="hang"><em class="italic">Simply Murder: The Battle of Fredericksburg, December 13, 1862</em> (with Kristopher D. White)</p>
<p class="hang"><em class="italic">That Furious Struggle: Chancellorsville and the High Tide of the Confederacy, May 1-4, 1863</em> (with Kristopher D. White)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Also.vue?9ebc7178